import apiClient from "./apiClient";

const BASE = "/api/Supplier";

// API returns supplierID (no `id`) — alias it so list/edit/filter code using `.id` works.
const withId = (s) => ({ ...s, id: s.supplierID });

export const getSuppliers = async () => {
  const res = await apiClient.get(`${BASE}/all`);
  return { ...res, data: (res.data || []).map(withId) };
};
export const getSupplier = async (id) => {
  const res = await apiClient.get(`${BASE}/${id}`);
  return { ...res, data: withId(res.data) };
};
export const createSupplier = (data) => apiClient.post(`${BASE}/save`, data);
export const updateSupplier = (id, data) => apiClient.post(`${BASE}/save`, { ...data, supplierID: id });
export const deleteSupplier = () => Promise.reject(new Error("Delete not supported by API"));
